import {
  BillDisplayStatus,
  BillStatus,
  BillType,
  PaymentProvider,
  SubscriptionProduct,
} from "@redotech/redo-billing-common/billing-display-labels";
import * as z from "zod";

export const billTypeSchema = z.nativeEnum(BillType);
export const billStatusSchema = z.nativeEnum(BillStatus);
export const billDisplayStatusSchema = z.nativeEnum(BillDisplayStatus);
export const subscriptionProductSchema = z.nativeEnum(SubscriptionProduct);
export const paymentProviderSchema = z.nativeEnum(PaymentProvider);

const paymentMethodInfoSchema_ = z.object({
  provider: paymentProviderSchema.nullable(),
  last4: z.string().nullable(),
  brand: z.string().nullable(),
});
export const paymentMethodInfoSchema: z.ZodType<PaymentMethodInfo> =
  paymentMethodInfoSchema_;
export interface PaymentMethodInfo
  extends z.infer<typeof paymentMethodInfoSchema_> {}

const billSchema_ = z.object({
  id: z.string(),
  type: billTypeSchema,
  status: billStatusSchema,
  displayStatus: billDisplayStatusSchema,
  startTime: z.date(),
  endTime: z.date(),
  balanceStart: z.number(),
  balanceEnd: z.number(),
  totalCharged: z.number(),
  totalPaid: z.number(),
  products: z.array(subscriptionProductSchema),
  createdAt: z.date(),
  currency: z.string().default("USD"),
  paymentMethod: paymentMethodInfoSchema.nullable(),
});
export const billSchema: z.ZodType<BillSchema> = billSchema_;
export interface BillSchema extends z.infer<typeof billSchema_> {}

const getBillsInput_ = z.object({
  pageSize: z.number().optional().default(25),
  offset: z.number().optional().default(0),
  sortKey: z
    .enum(["created_at", "start_time", "end_time", "status"])
    .optional(),
  sortDirection: z.enum(["asc", "desc"]).optional().default("desc"),
  status: billStatusSchema.optional(),
  excludeStatus: billStatusSchema.optional(),
});
export const getBillsInput: z.ZodType<GetBillsInput> = getBillsInput_;
export interface GetBillsInput extends z.infer<typeof getBillsInput_> {}

const getBillsOutput_ = z.object({
  bills: z.array(billSchema),
  total: z.number(),
  nextOffset: z.number().nullish(),
});
export const getBillsOutput: z.ZodType<GetBillsOutput> = getBillsOutput_;
export interface GetBillsOutput extends z.infer<typeof getBillsOutput_> {}

export const getBills = {
  name: "getBills" as const,
  input: getBillsInput,
  output: getBillsOutput,
};
